<template>

  <div v-if="editMode || filled">
    <div class="card-header">
      <i
        class="fas fa-pencil-alt"
        :title="$t('Edit')"
        v-if="!editable && editMode"
        @click.stop="editSection(true)"
        style="cursor: pointer; float: right;">
        </i>
      <strong>{{ $t('Languages') }}</strong>
    </div>
    <div
      v-if="editable"
      class="card-body">
      <form v-on:submit.prevent="save(candidateEdit)">
        
        <div
          v-if="candidateEdit.languages.length"
          class="mb-3">
          <div
            class="input-group mb-1"
            v-for="(item, index) in candidateEdit.languages"
            :key="index">
            <div class="form-control">
              {{ resources.language.find((v) => { return v.key===item.language }).name }}
            </div>
            <select class="form-control" v-model="item.level">
              <option value="4">{{ $t('Fluent') }}</option>
              <option value="3">{{ $t('Advanced') }}</option>
              <option value="2">{{ $t('Average') }}</option>
              <option value="1">{{ $t('Basic') }}</option>
            </select>
            <div class="input-group-append">
              <button class="btn btn-outline-secondary" type="button" @click="candidateEdit.languages.splice(index, 1)">{{ $t('Remove') }}</button>
            </div>
          </div>
          <ValidateMessage :error="validateErrors.languages" />
        </div>

        <div class="mb-3">
          <select class="form-control" @change="addItem">
            <option>{{ $t('Add language') }}</option>
            <option 
              v-for="(item, index) in languageOptions" 
              :key="index"
              :value="item.key">
              {{ item.name }}
              </option>
          </select>
        </div>

        <div :class="{'box-loading': loading}">
          <button
            type="submit"
            class="btn btn-primary">
            {{ $t('Save') }}
            </button>
          <button
            type="button"
            class="btn btn-light"
            @click.stop="editSection(false)">
            {{ $t('Cancel') }}
            </button>
        </div>
      </form>
    </div>
    <div
      v-if="!editable && filled"
      class="card-body">
      
      <div
        class="language-list">
        <span
          v-for="(item, index) in candidate.languages"
          :key="index">
          <strong>{{ getLanguageName(item.language) }}:</strong> {{ getLevelName(item.level) }}
          </span>
      </div>

    </div>
  </div>

</template>

<script>
export default {
  name: 'CandidateProfilelanguages',
  components: {
  },
  props: [
    'editMode'
  ],
  data () {
    return {
      loading: false,
      sectionEdit: false,
      candidateEdit: {},
      validateErrors: false
    }
  },
  created () {
  },
  computed: {
    editable () {
      return this.sectionEdit && this.editMode
    },
    candidate () {
      return this.$store.getters.getCandidate
    },
    resources () {
      return this.$store.getters.getResources
    },
    languageOptions () {
      return this.resources.language.filter(v => {
        return !this.candidateEdit.languages.find(a => a.language === v.key)
      })
    },
    filled () {
      return this.candidate.languages && this.candidate.languages.length
    }
  },
  methods: {
    addItem (event) {
      this.candidateEdit.languages.push({language: event.target.value, level: 4})
      event.target.value = ''
    },
    editSection (status) {
      this.sectionEdit = status
      this.candidateEdit = {
        _id: this.candidate._id,
        languages: Array.isArray(this.candidate.languages) ? this.candidate.languages : []
      }
    },
    save (data) {
      this.loading = true

      this.$store.dispatch('updateCandidate', data)
      .then((response) => {
        this.loading = false
        this.sectionEdit = false
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    getLevelName (key) {
      return {
        1: this.$t('Basic'),
        2: this.$t('Average'),
        3: this.$t('Advanced'),
        4: this.$t('Fluent')
      }[key]
    },
    getLanguageName (key) {
      return this.resources.language.find((v) => {
        return v.key === key
      }).name
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.language-list{
  overflow: hidden;
  width: 100%;
}
  .language-list > span{
    display: inline-block;
    padding: 4px 7px;
    border: 1px solid rgba(0,0,0,0.1);
    border-radius: 5px;
    margin: 2px; 
  }
</style>



// WEBPACK FOOTER //
// src/components/Candidate/Profile/CandidateProfileLanguages.vue